import { useDispatch } from 'react-redux'

import { startLabTestsBulkPricesSession } from '~/store/duck/bulkPrices'

import BulkPricingLink from '../bulk-prices/BulkPricingLink'

const LabTestBulkPricingLink = () => {
  const dispatch = useDispatch()

  const startNewSession = (force?: boolean) => {
    dispatch(
      startLabTestsBulkPricesSession({
        force,
        navigateTo: '/admin/catalog/lab-tests/prices',
      }),
    )
  }
  return <BulkPricingLink startNewSession={startNewSession} />
}

export default LabTestBulkPricingLink
